"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var styles_1 = require("styles");
var componentStyle = {
    input: {
        base: {
            width: '24px',
            height: '24px',
            marginRight: '16px',
            border: '1px solid #dfdfdf',
            borderRadius: '3px',
        },
        checked: {
            backgroundColor: '#f0f0f0',
        },
    },
    checkMark: {
        base: {
            display: 'none',
        },
        inputChecked: {
            display: 'block',
            borderBottom: "2px solid " + styles_1.FontColor.LightGray,
            borderLeft: "2px solid " + styles_1.FontColor.LightGray,
            borderTop: 'none',
            borderRight: 'none',
            width: '13px',
            height: '5px',
            transformOrigin: '0px 100% 0px',
            transform: 'rotateZ(-45deg) translate(-1px, 14px)',
        },
    },
};
var getInputStyle = function (style, props) { return ([
    style.input.base,
    props.checked && style.input.checked,
]); };
var getCheckMarkStyle = function (style, props) { return ([
    style.checkMark.base,
    props.checked && style.checkMark.inputChecked,
]); };
var CheckboxInput = (function (_super) {
    __extends(CheckboxInput, _super);
    function CheckboxInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxInput.prototype.render = function () {
        var otherProps = __rest(omit(this.props, ['checked', 'style']), []);
        return (React.createElement("div", __assign({ style: getInputStyle(componentStyle, this.props) }, otherProps),
            React.createElement("div", { style: getCheckMarkStyle(componentStyle, this.props) })));
    };
    CheckboxInput.defaultProps = {
        checked: false,
    };
    CheckboxInput = __decorate([
        Radium
    ], CheckboxInput);
    return CheckboxInput;
}(react_1.PureComponent));
exports.CheckboxInput = CheckboxInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/CheckboxInput.tsx
// module id = 288
// module chunks = 0